module.exports = __webpack_public_path__ + "img/obj_snow.ff951eb.webp";